module.exports = __webpack_public_path__ + "static/akb-3771811a6bfe312a91e216d1cb1f1fa9.png";